module.exports = __webpack_public_path__ + "static/media/click-high-05.1980d139.mp3";